import '@/fonts/blair/BlairITCStd-Light.ttf';
import '@/fonts/blair/BlairITCStd.ttf';



// WEBPACK FOOTER //
// ./fonts/index.js